@let query = formGroup.controls.search | formControlValueTyped$ | async;

<form [formGroup]="formGroup" (ngSubmit)="search(query ?? '')">
    <interacta-advanced-search-bar
        #advancedSearchBar
        [bgColor]="
            advancedSearchBar?.isInputFocused() ? 'surface-A' : 'surface-B'
        "
        [closedInputSize]="query ? '420' : '172'"
        [openLeft]="true"
        [search]="formGroup.controls.search"
        (inputFocused)="isAdvancedSearchOpen = false"
    >
        <div advanced-search class="mt-12">
            <!-- l'evento per chiudere la searchbar si basa su componenti montati, quindi devo nasconderli perché funzioni (non posso usare gli if) -->
            <div
                class="flex flex-col gap-y-12"
                [class.hidden]="isAdvancedSearchOpen"
            >
                <div class="flex gap-8">
                    <interacta-icon class="size-24" [icon]="'lightbulb'" />
                    <p>{{ 'SEARCH.HINT' | translate }}</p>
                </div>
                <interacta-separator [thickness]="'soft'" />
                <button
                    data-testid="search-advanced-button"
                    interacta-button
                    type="button"
                    [label]="'SEARCH.ADVANCED' | translate"
                    [size]="'small'"
                    [style]="'text-primary'"
                    (click)="setAdvancedSearch(true)"
                ></button>
            </div>

            <interacta-advanced-search-panel
                [class.hidden]="!isAdvancedSearchOpen"
                [formGroup]="formGroup.controls.advanced"
                (advancedSearch)="advancedSearch($event)"
                (closePanel)="setAdvancedSearch(false)"
            />
        </div>
    </interacta-advanced-search-bar>
</form>
